import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSessionData } from "../helpers/sessionDetailsParser";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);
  const [validUserType, setValidUserType] = useState(false);

  const [isLanding, setIsLanding] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);

  // Effect for setting valid user type
  useEffect(() => {
    if (getSessionData("user_type") === "SuperAdmin") {
      setValidUserType(true);
    }
  }, []);

  const menuItems = [
    {
      label: "Main Masters",
      isHeader: true,
    },
    validUserType && {
      id: "Products",
      label: "Products",
      icon: "ri-honour-line",
      link: "/product-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Products");
      },
    },
    {
      label: "Stocks",
      isHeader: true,
    },
    {
      id: "Product Types",
      label: "With HUID Stocks",
      icon: "ri-honour-line",
      link: "/productType-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ProductType");
      },
    },
    {
      id: "Product Types With Out HUID",
      label: "With Out HUID Stocks",
      icon: "ri-honour-line",
      link: "/productTypeWithOutHUIDBasePage-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ProductTypes With Out HUID Base Page");
      },
    },
    {
      id: "Moving Stocks History",
      label: "Moving Stocks History",
      icon: "ri-honour-line",
      link: "/move-stock-history",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Moving Stocks History");
      },
    },
    {
      label: "Users",
      isHeader: true,
    },
    {
      id: "Customers",
      label: "Customers",
      icon: "ri-honour-line",
      link: "/customer-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Customers");
      },
    },
    {
      id: "Users",
      label: "Users",
      icon: "ri-honour-line",
      link: "/user-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Users");
      },
    },
    {
      label: "Order Master",
      isHeader: true,
    },
    {
      id: "tables",
      label: "Sales",
      icon: "ri-honour-line",
      link: "/order-list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Sales");
      },
    },
    {
      label: "Reports",
      isHeader: true,
    },
    {
      id: "tables",
      label: "Sales Reports",
      icon: "ri-honour-line",
      link: "/order-report",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Sales Reports");
      },
    },
    {
      label: "Ledgers Reports",
      isHeader: true,
    },
    {
      id: "tables",
      label: "Customer Balance",
      icon: "ri-honour-line",
      link: "/ledgers-report",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Ledgers Reports");
      },
    },
    // {
    //   id: "tables",
    //   label: "Speech",
    //   icon: "ri-honour-line",
    //   link: "/speech",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIscurrentState("Speech");
    //   },
    // },
    // {
    //   label: "Personal Information",
    //   isHeader: true,
    // },
    // {
    //   id: "Personal Information",
    //   label: "Personal Information",
    //   icon: "ri-honour-line",
    //   link: "/personalDetails-list",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIscurrentState("Personal Information");
    //   },
    // },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
